<template lang="pug"></template>

<script>
import connect from "../scripts/database.js";
import { Quotes } from "../scripts/quotes.js";
import Accounts from "../scripts/accounts.js";
import Activity from "../scripts/activity.js";

export default {
  data() {
    return {
      productTitle: "",
      productId: "",
      productImage: "",
      productLink: "",
      productOptions: [],
      productQuantity: 0
    };
  },
  methods: {
    buildProductOptions(variations) {
      this.productOptions = [];

      if (variations) {
        for (var key in variations) {
          if (variations.hasOwnProperty(key)) {
            var obj = {
              name: key,
              value: variations[key]
            };

            this.productOptions.push(obj);
          }
        }
      }
    },
    buildProductID: function() {
      var str = this.productTitle;
      if (this.productOptions.length > 0) {
        var suffix = this.productOptions.map(opt => `${opt.name}:${opt.value}`);
        var sum = this.characterSum(suffix.join(";"));
        suffix = sum.toString(16);
        str = `${str}-${suffix}`;
      }
      return str;
    },
    characterSum: function(str) {
      var sum = 0;
      for (let i = 0; i < str.length; i++) {
        if (i % 2) {
          if (str.charCodeAt(i) % 2) {
            sum += str.charCodeAt(i);
          } else {
            sum -= str.charCodeAt(i);
          }
        } else {
          if (str.charCodeAt(i) % 2) {
            sum -= str.charCodeAt(i);
          } else {
            sum += str.charCodeAt(i);
          }
        }
      }
      return sum;
    },
    createId: function(str) {
      var sum = 0;
      for (let i = 0; i < str.length; i++) {
        sum += str.charCodeAt(i);
      }
      return sum;
    },
    newSession(userId = "anon") {
      let date = new Date();

      let u_part =
        this.createId(userId.substring(userId.length - 5)) +
        date.getFullYear() +
        date.getMonth();
      let ms = date.getMilliseconds() + Math.random() * 1000000;
      let t_part = `${(date.getFullYear() + date.getMonth() + ms).toString(
        16
      )}`.substr(0, 4);

      var forUser = !this.$root.currentUser.guest
        ? this.$root.currentUser.uid
        : null;

      var session = {
        id: `MLQ-${u_part.toString(16)}-${t_part}`,
        items: [],
        forUser: forUser,
        state: "draft"
      };

      this.$root.activeDraft = session;

      if (!this.$root.currentUser.guest) {
        Activity.userActivity(this.$root.currentUser, "request:new", {
          quote: session
        });
      }
    },
    addToSession() {
      if (!this.$root.activeDraft) {
        this.newSession();
      }

      var productID = this.buildProductID();
      var notes = this.productOptions
        .map(opt => `${opt.name}: ${opt.value}`)
        .join("\n");
      let result = this.$root.activeDraft.items.find(
        item => item.product.id == productID
      );
      let currentSite = this.$root.currentSite;
      if (!result) {
        this.$root.activeDraft.items.push({
          product: {
            title: this.productTitle,
            id: productID,
            image: this.productImage,
            link: this.productLink
          },
          notes: notes,
          quantity: this.productQuantity,
          site: currentSite
        });
      } else {
        result.quantity =
          parseInt(result.quantity) + parseInt(this.productQuantity);
      }

      //Restart checkout steps
      this.$root.$emit("restart");

      if (this.$root.activeDraft) {
        sessionStorage.setItem(
          "draft_quotes",
          JSON.stringify(this.$root.activeDraft)
        );
      }

      if (!this.$root.currentUser.guest) {
        Accounts.getAccount(this.$root.currentUser.uid).then(results => {
          let draftQuote = {
            id: this.$root.activeDraft.id,
            address: {
              addressData: {
                administrative_area_level_1: results.state,
                country: results.country,
                locality: results.city,
                postal_code: results.postalCode,
                street_number: results.street,
                route: ""
              },
              string: `${results.street}, ${results.city}, ${results.state} ${results.postalCode}, ${results.country}`
            },
            assignedTo: null,
            deliveryTimeframe: null,
            forUser: this.$root.currentUser.uid,
            hasDock: null,
            items: this.$root.activeDraft.items,
            lastUpdated: Date.now(),
            lastUpdatedBy: this.$root.currentUser.uid,
            lastViewed: this.$root.currentUser.uid,
            notes: null,
            optionsConsent: null,
            specConsent: null,
            state: this.$root.activeDraft.state
          };

          Quotes.createQuote(draftQuote);
        });

        Activity.userActivity(this.$root.currentUser, "request:addProduct", {
          product: {
            directoryURL: "/",
            fullLink: this.productLink,
            id: productID,
            image: this.productImage,
            quantity: this.productQuantity,
            title: this.productTitle
          }
        });
      }

      this.$root.currentState = "draft";
      if (this.$root.env != "development") {
        this.trackGAAddProduct();
      }
    },
    trackGAAddProduct() {
      try {
        dataLayer.push({
          event: "addToCart",
          ecommerce: {
            currencyCode: "USD",
            add: {
              products: [
                {
                  id: this.productId,
                  name: this.productTitle,
                  quantity: this.productQuantity
                }
              ]
            }
          }
        });
      } catch (e) {
        console.warn("Google Analytics is not available", e);
      }
    }
  },
  mounted() {
    var buttonsContainer = document.querySelectorAll(".add-to-quote-cart");
    var buttons = document.querySelectorAll(".add-to-quote-cart button");

    buttons.forEach((button, index) => {
      button.addEventListener("click", () => {
        if (!this.$root.open) {
          this.$root.open = true;
        }
        this.productTitle = buttonsContainer[index].getAttribute(
          "product-title"
        );
        this.productId = buttonsContainer[index].getAttribute("product-id");
        this.productImage = buttonsContainer[index].getAttribute(
          "product-image"
        );
        this.productLink = buttonsContainer[index].getAttribute("product-link");
        this.productQuantity = buttonsContainer[index].getAttribute(
          "product-quantity"
        );

        if (
          buttonsContainer[index].getAttribute("product-variations").length > 0
        ) {
          var productVariations = JSON.parse(
            buttonsContainer[index].getAttribute("product-variations")
          );
        } else {
          var productVariations = {};
        }

        this.buildProductOptions(productVariations);

        this.addToSession();
      });
    });
  }
};
</script>
